import {
  CheckBolderIcon,
  Flex, SidebarMenuItem,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useAccountContext } from '../../../contexts';
import { Stages } from '../../../types/Stages';
import { DipTypes } from '../../../api/useProductsApi';
import { SidebarFooterItemValue } from './SidebarFooterItem';

const SidebarFooterMenuItem = styled(SidebarMenuItem)` ${({ theme }) => `
  background: ${theme.colours.neutral[9]};

  a {
    &:hover {
      background: unset;
    }
  }
`}`;

const SidebarDipMenuItem = styled(SidebarFooterMenuItem)<{dip?: DipTypes}>` ${({ theme, dip }) => `
  background: ${(dip === null
    ? theme.colours.neutral[7]
    : dip === DipTypes.PASS
      ? theme.colours.success[2]
      : theme.colours.danger[2])};
`}`;

const SidebarDipMenuTextContainer = styled(Flex)` ${({ theme }) => `
  font-family: Montserrat;
  font-size:${theme.fontSize[4]};
  font-weight:${theme.fontWeight.bold};
  gap: ${theme.padding[1]};
  align-items:center;
`}`;

const SidebarDipMenuTextOutcome = styled.span` ${({ theme }) => `
  letter-spacing: ${theme.padding[1]};
`}`;

const SidebarFooterItemContainer = styled(Flex)` ${({ theme }) => `
  justify-content: space-between;
  align-items:center;
  font-weight:${theme.fontWeight.bold};
  font-size:${theme.fontSize[1]};
  padding:${theme.padding[1]} 0px ${theme.padding[1]} 0px;
`}`;

const PassFailMarkerIconContainer = styled(Flex)` ${({ theme }) => `
  align-items:center;
  justify-content:center;
  background:${theme.colours.primary[1]};
  width:14px;
  height:14px;
  border-radius:7px;
`}`;

const DipPassFailMarkerIconContainer = styled(PassFailMarkerIconContainer)<{dip: DipTypes}>` ${({ theme, dip }) => `
    background:${dip === DipTypes.PASS ? theme.colours.success[4] : theme.colours.danger[4]};
`}`;

const PassFailMarkerIcon = styled.i` ${({ theme }) => `
    color:${theme.colours.neutral[10]};
    font-size:${theme.fontSize[1]};
`}`;

function DipPassFailMarker({ dip = DipTypes.FAIL }:{dip?: DipTypes}) {
  return (
    <>
      {dip !== null && (
        <DipPassFailMarkerIconContainer dip={dip}>
          {dip === DipTypes.PASS ? (
            <CheckBolderIcon />
          ) : (
            <PassFailMarkerIcon className="mi-close" />
          )}
        </DipPassFailMarkerIconContainer>
      )}
    </>
  );
}

export default function ProductSidebarFooter() {
  const { account, summary } = useAccountContext();
  const { stage } = account ?? {};

  return (
    <>
      {`${stage}` !== `${Stages.CreditDecision}` && (
      <>
        <SidebarFooterMenuItem>
          <SidebarFooterItemContainer>
            <div>Product:</div>
            <SidebarFooterItemValue>{summary?.productName === null ? '-' : summary?.productName}</SidebarFooterItemValue>
          </SidebarFooterItemContainer>
        </SidebarFooterMenuItem>

        <SidebarDipMenuItem dip={summary?.decisionInPrincipleOutcome}>
          <SidebarFooterItemContainer>
            <div>Decision in principle:</div>
            <SidebarDipMenuTextContainer>
              <DipPassFailMarker dip={summary?.decisionInPrincipleOutcome} />
              <SidebarDipMenuTextOutcome>
                {summary?.decisionInPrincipleOutcome === null
                  ? '-'
                  : summary?.decisionInPrincipleOutcome === DipTypes.PASS
                    ? 'PASS'
                    : 'FAIL'}
              </SidebarDipMenuTextOutcome>
            </SidebarDipMenuTextContainer>
          </SidebarFooterItemContainer>
        </SidebarDipMenuItem>
      </>
      )}
    </>
  );
}
